import { parseApiError, parseNetworkOrUnknownError, type ParsedApiError } from '@loctopus/shared';
import { ApiRequestError, BASE_URL } from './api';

/**
 * The one-line adapter every apps/dashboard page needs between `ApiRequestError` (this app's own
 * error class, lib/api.ts) and @loctopus/shared's app-agnostic `parseApiError`. Use this instead
 * of writing the adapter inline per-page (it used to be duplicated - now it's just this).
 */
export function toParsedError(err: unknown): ParsedApiError {
  if (err instanceof ApiRequestError) {
    // A real fetch-level failure (the API wasn't reachable at all) - never show the browser's own
    // raw message, always the shared plain-language one, with the address we actually tried.
    if (err.code === 'network_error') {
      return parseNetworkOrUnknownError(err, BASE_URL);
    }
    return parseApiError({
      code: err.code,
      message: err.message,
      details: err.details,
      requestId: err.requestId,
      httpStatus: err.status,
    });
  }
  return parseNetworkOrUnknownError(err, BASE_URL);
}
